export default {
  sidebar: {
    showSidebar: 'Afișați bara laterală',
    hideSidebar: 'Ascundeți bara laterală',
    switchSide: 'Partea de comutare',
  }
}
